

import React from 'react';
import { useAuth } from '../../app/useAuth';

const LoggedOut = () => {
    const { loginWithRedirect } = useAuth();

    return (
        <div style={{ 
            textAlign: 'center', 
            marginTop: '100px',
            padding: '20px'
        }}>
            <h1>You've been logged out</h1>
            <p>Thanks for using OhioIoT!</p>
            <div style={{ marginTop: '30px' }}>
                <button 
                    onClick={() => loginWithRedirect()}
                    style={{ margin: '0 10px', padding: '10px 20px' }}
                >
                    Log Back In
                </button>
                <button 
                    onClick={() => window.location.href = '/'}
                    style={{ margin: '0 10px', padding: '10px 20px' }}
                >
                    Go to Homepage
                </button>
            </div>
        </div>
    );
};

export default LoggedOut;